import React from "react";
import { Container, Row, Col } from "reactstrap";
import styles from "./sprints.module.scss";
// import Button from "../../elements/layout";

const SprintsSection = () => (
    <div id="sprints" className="section blue">
        <Container >

            <Row>
                <Col><h2>Šprinty</h2></Col>
            </Row>
            <Row className={styles.centerContent}>
                <Col xs="10">
                    <div className={styles.sprintWrapper}>
                        <h4>Šprint 1 - Vanilla</h4>
                        <p className="date">8. OKT 2018 - 22. OKT 2018</p>
                        <p className="description">Úvodný šprint bol venovaný prvotnej analýze dostupných technológií, ktoré využijeme pri vývoji.
                        </p>
                    </div>
                </Col>
            </Row>
            <div className={styles.connector}></div>
            <Row className={styles.centerContent}>
                <Col xs="10">
                    <div className={styles.sprintWrapper}>
                        <h4>Šprint 2 - The Burning Crusade</h4>
                        <p className="date">22. OKT 2018 - 12. NOV 2018</p>
                        <p className="description">
                            Vytvorenie prvotného GUI prototypu, ako aj vytvorenie architektonického návrhu aplikácie spolu s dátovým modelom.
                        </p>
                    </div>
                </Col>
            </Row>
            <div className={styles.connector}></div>
            <Row className={styles.centerContent}>
                <Col xs="10">
                    <div className={styles.sprintWrapper}>
                        <h4>Šprint 3 - Wrath of the Lich King</h4>
                        <p className="date">12. NOV 2018 - 26. NOV 2018</p>
                        <p className="description">Rozšírenie GUI o výsledky simulácie. Nasadenie prvotného simulačného servera spolu s databázovým serverom.
                        </p>
                    </div>
                </Col>
            </Row>
            <div className={styles.connector}></div>
            <Row className={styles.centerContent}>
                <Col xs="10">
                    <div className={styles.sprintWrapper}>
                        <h4>Šprint 4 - Cataclysm</h4>
                        <p className="date">26. NOV 2018 - 10. DEC 2018</p>
                        <p className="description">Zlepšenia GUI a integrácia všetkých komponentov.
                        </p>
                    </div>
                </Col>
            </Row>
            <div className={styles.connector}></div>
            <Row className={styles.centerContent}>
                <Col xs="10">
                    <div className={styles.sprintWrapper}>
                        <h4>Šprint 5 - Mists of Pandaria</h4>
                        <p className="date">26. NOV 2018 - 10. DEC 2018</p>
                        <p className="description">Zlepšenie ovládania v schématickom a mapovom zobrazení. Editovateľné atribúty prvkov.
                        </p>
                    </div>
                </Col>
            </Row>
            <div className={styles.connector}></div>
            <Row className={styles.centerContent}>
                <Col xs="10">
                    <div className={styles.sprintWrapper}>
                        <h4>Šprint 6 - Warlords of Draenor</h4>
                        <p className="date">14. FEB 2018 - 28. FEB 2018</p>
                        <p className="description">Analýza možností prehrávania simulácií. Vizuálny update aplikácie.
                        </p>
                    </div>
                </Col>
            </Row>
            <div className={styles.connector}></div>
            <Row className={styles.centerContent}>
                <Col xs="10">
                    <div className={styles.sprintWrapper}>
                        <h4>Šprint 7 - Legion</h4>
                        <p className="date">28. FEB 2018 - 14. MAR 2018</p>
                        <p className="description">Pridanie ďalšieho simulačného jadra. Rozšírené výsledky simulácie
                        </p>
                    </div>
                </Col>
            </Row>
            <div className={styles.connector}></div>
            <Row className={styles.centerContent}>
                <Col xs="10">
                    <div className={styles.sprintWrapper}>
                        <h4>Šprint 8 - Battle For Azeroth</h4>
                        <p className="date">14. MAR 2018 - 28. FEB 2018</p>
                        <p className="description">Používateľské testovanie. Zapracovanie pripomienok.
                        </p>
                    </div>
                </Col>
            </Row>
            <div className={styles.connector}></div>
            <Row className={styles.centerContent}>
                <Col xs="10">
                    <div className={styles.sprintWrapper}>
                        <h4>Šprint 9 - Cataclysm 2</h4>
                        <p className="date">28. NOV 2018 - 11. APR 2018</p>
                        <p className="description">Interaktívne prehrávanie simulácie. Implementácia správcu knižníc prvkov.
                        </p>
                    </div>
                </Col>
            </Row>
            <div className={styles.connector}></div>
            <Row className={styles.centerContent}>
                <Col xs="10">
                    <div className={styles.sprintWrapper}>
                        <h4>Šprint 10 - Reign of Chaos</h4>
                        <p className="date">11. APR 2018 - 25. APR 2018</p>
                        <p className="description">Vylepšenia a prípravy na TP CUP.
                        </p>
                    </div>
                </Col>
            </Row>
            <div className={styles.connector}></div>
            <Row className={styles.centerContent}>
                <Col xs="10">
                    <div className={styles.sprintWrapper}>
                        <h4>Šprint 11 - The Frozen Throne</h4>
                        <p className="date">30. APR 2018 - 10. MÁJ 2018</p>
                        <p className="description">Opravy a finalizácia dokumentácie inžinierskeho diela.
                        </p>
                    </div>
                </Col>
            </Row>

            {/* <Row>
                <Col className={`${styles.centerContent} ${styles.showAllButton}`}>
                    <Button dark>Zobraziť všetky šprinty</Button>
                </Col>
            </Row> */}

        </Container>
    </div>
);

export default SprintsSection;
